import { makeRequester } from "./base";

export const post = url => makeRequester(url, { method: "POST" });

export const put = url => makeRequester(url, { method: "PUT" });

export const deleteMethod = url => makeRequester(url, { method: "DELETE" });
